export const colors = {
	purple: {
		100: "#EFE5F4",
		200: "#D1B3E0",
		300: "#E0CCEB",
		400: "#B380CC",
		500: "#660099",
		600: "#461E5F",
	},
	purpleAlpha: {
		200: "#66009920",
		400: "#66009950",
		500: "#66009933",
	},
	orange: {
		500: "#FA6423",
		500.25: "#FA642325",
	},
	orangeAlpha: {
		500: "#FA642340",
	},
	yellow: {
		500: "#FFE279",
		500.5: "#FFE27980",
		600: "#F5D253",
		800: "#8A5627",
		900: "#8A5627",
	},
	red: {
		300: "#FCE4EF",
		500: "#CC1F59",
		700: "#8F2052",
	},
	green: {
		200: "#EDF8E8",
		250: "#32a04b25",
		300: "#99CC33",
		500: "#32A04B",
		700: "#225C3D",
	},
	greenAlpha: {
		500: "#32A04B40",
	},
	white: {
		100: "#E8E9ED",
		200: "#EEEEEE",
		500: "#FFFFFF",
		550: "#F6F6F6",
		600: "#F7F7F7",
		700: "#DDDDDD",
		800: "#D4D4D4",
	},
	gray: {
		50: "#ebeaea",
		100: "#DDDDDD",
		200: "#999999",
		300: "#86888C",
		500: "#696969",
		600: "#666666",
		600.2: "#66666620",
		700.2: "#2A2A3C33",
	},
	alphaGray: {
		500: "#00000014",
	},
	black: {
		500: "#000000",
	},
	blackAlpha: {
		200: "#42426020",
		400: "#191919E5",
		500: "#191919B2",
	},
	redAlpha: {
		500: "#CC1F5940",
		350: "#CC1F5935",
	},
	text: {
		muted: "#696969",
		dark: "#000000",
		light: "#FFFFFF",
	},
	shadow: {
		100: "#00000012",
		200: "#00000014",
		300: "#00000020",
		600: "#00000066",
	},
	status: {
		error: "#CC1F59",
		success: "#32A04B",
		warning: {
			500: "#FFE279",
			600: "#F5D253",
		},
	},
} as const;
